import React, { useState, useEffect } from "react";
import "../pages/styles.css";
import Header from "../components/header";
import markersection from "../assets/home/markersection.png";
import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";
import {
  LazyLoadImage,
} from "react-lazy-load-image-component";
import { NavLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import img1 from "../assets/cover_letters/1.webp";
import img2 from "../assets/cover_letters/2.webp";
import img3 from "../assets/cover_letters/3.webp";
import img4 from "../assets/cover_letters/4.webp";
import img5 from "../assets/cover_letters/2.webp";
import img6 from "../assets/cover_letters/4.webp";

import img8 from "../assets/promotionmaker/6.webp";
import img9 from "../assets/promotionmaker/7.webp";
import img10 from "../assets/promotionmaker/8.webp";

import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import api from "../config/api";

const Catelog = () => {
  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${markersection}`);
  const isLang = useSelector((state) => state.authReducer.lang);


  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(false);
  };

  const handleCloseModel = () => setOpenModel(false);
  const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api.API_URL}/aapi/tempbycat.php?title=Cover Letter`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header />
      <div className="pt-20 bg-purple-500">
        <div className="grid grid-cols-2 p-5">
        <div className="p-10 ml-5 text-white text-[16px] font-[100px]">
  <p className="text-4xl font-semibold">
    {isLang === "eng" ? "Cover Letter" : "خطاب الغلاف"}
  </p>
  <br />
  <p style={{ fontSize: "16px" }}>
    {isLang === "eng"
      ? `Elevate your Cover Letter with Maker4U's intuitive Cover Letter
         builder, enabling you to create an outstanding Cover Letter in minutes.
         Explore a diverse collection of meticulously designed templates,
         complemented by official fonts and other design elements, all tailored
         to help you showcase your skills effectively.`
      : `ارفع مستوى خطاب الغلاف الخاص بك باستخدام أداة إنشاء خطابات الغلاف من Maker4U،
         مما يتيح لك إنشاء خطاب غلاف متميز في دقائق. استكشف مجموعة متنوعة من القوالب
         المصممة بعناية، والمكملة بالخطوط الرسمية والعناصر التصميمية الأخرى،
         وكل ذلك مصمم لمساعدتك في عرض مهاراتك بشكل فعال.`}
    <br />
    <br />
    {isLang === "eng"
      ? `With Maker4U's user-friendly platform, you don't need design skills. 
         Simply unleash your creativity and craft a cover letter that grabs the attention
         of HR departments from the get-go. Stand out from the competition and 
         increase your chances of landing interviews with ease.`
      : `مع منصة Maker4U سهلة الاستخدام، لا تحتاج إلى مهارات تصميم. 
         ببساطة أطلق العنان لإبداعك وأنشئ خطاب غلاف يجذب انتباه أقسام الموارد البشرية 
         من اللحظة الأولى. تميز عن المنافسة وزد فرصك في الحصول على مقابلات بسهولة.`}
    <br />
    <br />
    {isLang === "eng"
      ? `Don't miss out on the opportunity to impress potential employers. 
         Start building your remarkable Cover Letter with Maker4U today and 
         take the first step towards advancing your career.`
      : `لا تفوت الفرصة لإثارة إعجاب أصحاب العمل المحتملين. 
         ابدأ في بناء خطاب الغلاف المتميز الخاص بك مع Maker4U اليوم 
         واتخذ الخطوة الأولى نحو تقدم حياتك المهنية.`}
  </p>
</div>


          <div>
            <LazyLoadImage src={`${img1}`} className="w-full h-full px-4"/>
          </div>
        </div>
      </div>
      <p className="text-[32px] text-center font-[500] mt-10">
  {isLang === "eng"
    ? "Get inspired by expertly crafted cover letter examples"
    : "استلهم من أمثلة خطابات الغلاف المصممة باحترافية"}
</p>

<div className="flex justify-center ">
  <div className="text-center" style={{ maxWidth: "840px" }}>
    <p style={{ fontSize: "16px" }}>
      {isLang === "eng"
        ? `Start your Cover design journey with confidence, thanks to Maker4U's comprehensive
           selection of professional Cover letter templates. Unsure of where to begin? Fear not! Our
           user-friendly platform offers an abundance of well-designed templates and cover examples
           to spark your inspiration.`
        : `ابدأ رحلتك في تصميم خطاب الغلاف بثقة، بفضل مجموعة Maker4U الشاملة من القوالب
           الاحترافية لخطابات الغلاف. لست متأكدًا من أين تبدأ؟ لا تقلق! توفر منصتنا
           سهلة الاستخدام مجموعة وفيرة من القوالب المصممة جيدًا وأمثلة خطابات الغلاف
           لإلهامك.`}
    </p>
  </div>
</div>

      <div className="card-container"   style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        {data.map((item) => (
          <NavLink
            to={`/CoverBuilder/${item.templetepath}`} 
            className="hover:no-underline"
          >
            <Card sx={{ maxWidth: 225 }}>
              <CardMedia
                component="img"
                alt="Cover Letter Template"
                height="120"
                image={`${api.API_URL}/aapi/templetes/${item.imagepath}`}
              />
              <CardContent
                className=" m-0 h-8 pb-3 text-left font-medium"
                style={{ fontFamily: "poppins" }}
              >
                <Typography gutterBottom variant="h8" component="div">
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </NavLink>
        ))}
      </div>
      <div className="flex items-center justify-center">
        <NavLink 
         to="/resumeMaker/temp/Cover Letter">
        <Button
          variant="contained"
          onClick={handleOpen}
          style={{
            marginTop: "10px",
            borderRadius: "20px",
            width: "180px",
            backgroundColor:
              "#882ED8",
          }}
        >
          SHOW MORE
        </Button>
        </NavLink>
      </div>

      <p className="my-16 text-[32px] text-center font-[500]">
  {isLang === "eng"
    ? "Pick one of many world-class templates and build your cover letter in minutes"
    : "اختر واحدة من العديد من القوالب العالمية وبنِ خطاب التغطية الخاص بك في دقائق"}
</p>


      <div className="imageGrid">
        <div>
          <LazyLoadImage src={`${img1}`} />
        </div>
        <div>
          <div onClick={() => setImg(`${img1}`)}>
            <LazyLoadImage src={`${img1}`} />
          </div>
          <div onClick={() => setImg(`${img2}`)}>
            <LazyLoadImage src={`${img2}`} />
          </div>
          <div onClick={() => setImg(`${img3}`)}>
            <LazyLoadImage src={`${img3}`} />
          </div>
        </div>
      </div>

      <div className="catelogTextContainer">
  <div className="catelogText">
    <p style={{ fontSize: "16px" }}>
      {isLang === "eng"
        ? `Transform your Cover letter into a masterpiece with Maker4U's array of world-class templates, designed to impress at first glance. With our intuitive platform, you can craft a professional cover letter in minutes, showcasing your skills and experiences with ease.
          
          <br/><br/>
          Simply upload your photo, choose a sketch effect you like, and instantly see the magic transformation of turning your photo to art! Your sketch drawing is ready! So, try out the cutting-edge tool now and generate stunning artwork with AI in seconds.`
        : `حوّل خطاب التغطية الخاص بك إلى تحفة فنية باستخدام مجموعة قوالب Maker4U العالمية، المصممة لترك انطباع أولي رائع. باستخدام منصتنا السهلة الاستخدام، يمكنك إنشاء خطاب تغطية احترافي في دقائق، مع عرض مهاراتك وتجاربك بسهولة.
          
          <br/><br/>
          فقط قم بتحميل صورتك، اختر التأثير الذي تفضله، وشاهد سحر التحول الفوري لصورتك إلى فن! رسمك التخيلي جاهز! جرب الأداة المتطورة الآن وولّد أعمالاً فنية مذهلة باستخدام الذكاء الاصطناعي في ثوانٍ.`}
    </p>
  </div>
</div>


<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img4}`} />
  </div>
  <div></div>
  <div>
    <p>
      {isLang === "eng"
        ? "Customize Your Own Cover Letter"
        : "خصص خطاب التغطية الخاص بك"}
    </p>
    <p style={{ fontSize: "16px" }}>
      {isLang === "eng"
        ? `Tailor your cover letter to perfection with Maker4U's intuitive
          customization features, empowering you to showcase your unique
          skills and experiences with flair. Our platform offers a seamless
          experience, allowing you to create a personalized cover letter that stands
          out from the crowd.`
        : `قم بتخصيص خطاب التغطية الخاص بك إلى الكمال باستخدام ميزات التخصيص البديهية من Maker4U، مما يتيح لك عرض مهاراتك وتجاربك الفريدة بأسلوب رائع. توفر منصتنا تجربة سلسة، مما يتيح لك إنشاء خطاب تغطية مخصص يبرز بين الحشود.`}
    </p>
  </div>
</div>

<div>
  {isLang === "eng" ? (
    // English content
    <div>
      <p>Turn Portrait Photo to Pencil Sketch - Pencil Portrait Sketch</p>
      <p style={{ fontSize: "16px" }}>
        Want a professional pencil portrait sketch and save time? Use our image
        to drawing converter, effortlessly convert image to sketch portrait
        drawing in a few simple steps. It’s not only fast but provides
        high-definition images as well. Ease yourself and convert photo to
        sketch online free now with Fotor!
        <br /><br />
        With Maker4U's easy-to-use tools, you can customize every aspect of your
        cover—from layout and design to fonts and colors. Whether you're aiming
        for a sleek and modern look or a classic and sophisticated style, the
        possibilities are endless.
        <br /><br />
        Explore your creativity and make your cover letter truly your own. Start
        crafting your personalized masterpiece with Maker4U today and take the
        first step towards your dream career.
      </p>
    </div>
  ) : (
    // Arabic content
    <div>
      <p>تحويل صورة البورتريه إلى رسم بالقلم الرصاص - رسم بورتريه بالقلم الرصاص</p>
      <p style={{ fontSize: "16px" }}>
        هل تريد رسم بورتريه احترافي بالقلم الرصاص وتوفير الوقت؟ استخدم محول الصور
        إلى رسم، وحوّل صورتك إلى رسم بورتريه بسهولة وفي خطوات بسيطة. إنه ليس
        سريعًا فحسب، بل يقدم صورًا عالية الوضوح أيضًا. سهّل على نفسك وحوّل الصورة
        إلى رسم مجانًا الآن مع فوتر!
        <br /><br />
        باستخدام أدوات Maker4U السهلة الاستخدام، يمكنك تخصيص كل جانب من جوانب
        الغلاف الخاص بك - من التصميم والتخطيط إلى الخطوط والألوان. سواء كنت
        تهدف إلى مظهر حديث وأنيق أو أسلوب كلاسيكي وراقٍ، فإن الاحتمالات لا حصر
        لها.
        <br /><br />
        استكشف إبداعك واجعل غلاف خطابك يعبر عن شخصيتك. ابدأ الآن في تصميم تحفتك
        الشخصية مع Maker4U واتخذ الخطوة الأولى نحو حياتك المهنية المثالية.
      </p>
    </div>
  )}
</div>


<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img6}`} />
  </div>
  <div></div>
  <div>
    {isLang === "eng" ? (
      // English content
      <div>
        <p>Beautify Your Profile Image Well on Cover Letter</p>
        <p style={{ fontSize: "16px" }}>
          Make a lasting impression with Maker4U's innovative feature to enhance
          your profile image on your cover letter. Our platform empowers you to
          beautify your photo, ensuring that your professional appearance shines
          through.
          <br /> <br />
          With Maker4U's advanced editing tools, you can easily adjust the
          brightness, contrast, and color balance of your profile image to
          achieve the perfect look. Whether you're aiming for a polished and
          professional appearance or a warm and approachable vibe, our
          customization options have you covered.
        </p>
      </div>
    ) : (
      // Arabic content
      <div>
        <p>تجميل صورة ملفك الشخصي على خطاب التغطية</p>
        <p style={{ fontSize: "16px" }}>
          اترك انطباعًا دائمًا باستخدام ميزة Maker4U المبتكرة لتحسين صورة ملفك
          الشخصي على خطاب التغطية. تتيح لك منصتنا تجميل صورتك، مما يضمن أن مظهرك
          الاحترافي يبرز.
          <br /> <br />
          باستخدام أدوات التحرير المتقدمة من Maker4U، يمكنك بسهولة ضبط السطوع
          والتباين وتوازن الألوان لصورتك الشخصية لتحقيق المظهر المثالي. سواء
          كنت تهدف إلى مظهر مصقول واحترافي أو إلى أسلوب دافئ وودود، فإن خيارات
          التخصيص لدينا تغطي كل احتياجاتك.
        </p>
      </div>
    )}
  </div>
</div>


<div className="catelogAITexContainer">
  <div className="catelogText text-left">
    {isLang === "eng" ? (
      // English content
      <>
        <p style={{ fontSize: "40px", marginBottom: "20px", textAlign: "center" }}>
          How to Make a Cover Letter
        </p>
        <p style={{ fontSize: "16px" }}>
          Crafting a standout cover letter is essential for job holders:
          <br /> <b>1 - Choose Format:</b> Select the appropriate format for your background.
          <br /><b>2 - Include Contact Info:</b> Provide clear and professional contact details, 
          including name, phone, email, and LinkedIn profile. <br /> Write Objective: 
          Craft a concise summary or objective statement tailored to your career goals.
          <br />
          <b>3 - List Work Experience:</b> Highlight key responsibilities and achievements in reverse chronological order.
          <br /> Showcase Education: Include relevant educational background, such as degrees and honors.
          <br />
          <b>4 - Highlight Skills:</b> Feature pertinent technical and soft skills to align with job requirements. 
          Review and Edit: Ensure clarity, grammar, and consistency through thorough review and editing.
          <br />
          <b>5 - Save and Send:</b> Save your cover letter as a PDF and follow employer instructions for submission.
        </p>
      </>
    ) : (
      // Arabic content
      <>
        <p style={{ fontSize: "40px", marginBottom: "20px", textAlign: "center" }}>
          كيفية كتابة خطاب تغطية
        </p>
        <p style={{ fontSize: "16px" }}>
          إعداد خطاب تغطية مميز ضروري لحاملي الوظائف:
          <br /> <b>1 - اختيار التنسيق:</b> اختر التنسيق المناسب لخلفيتك.
          <br /><b>2 - تضمين معلومات الاتصال:</b> قدم معلومات اتصال واضحة واحترافية، 
          بما في ذلك الاسم، الهاتف، البريد الإلكتروني، وملف لينكد إن. <br /> كتابة الهدف: 
          اكتب ملخصًا موجزًا أو بيان الهدف مخصص لأهدافك المهنية.
          <br />
          <b>3 - سرد الخبرات العملية:</b> أبرز المسؤوليات الرئيسية والإنجازات بترتيب زمني عكسي.
          <br /> استعراض التعليم: أدرج خلفيتك التعليمية ذات الصلة، مثل الدرجات والتكريمات.
          <br />
          <b>4 - تسليط الضوء على المهارات:</b> أبرز المهارات الفنية والناعمة ذات الصلة لمتطلبات الوظيفة.
          مراجعة وتحرير: تأكد من الوضوح، القواعد، والاتساق من خلال المراجعة والتحرير الشامل.
          <br />
          <b>5 - الحفظ والإرسال:</b> احفظ خطاب التغطية كملف PDF واتبع تعليمات صاحب العمل للإرسال.
        </p>
      </>
    )}
  </div>
</div>

<div className="cardContainer">
  <div>
    <div>
      <LazyLoadImage src={`${img8}`} />
    </div>
    <div>
      {isLang === "eng" ? (
        <>
          <p>1. Include Media</p>
          <p style={{ fontSize: "16px" }}>
            Compile images or movies from stock libraries or computers into the scenario. Add some effects if you like as well.
          </p>
        </>
      ) : (
        <>
          <p>1. إضافة الوسائط</p>
          <p style={{ fontSize: "16px" }}>
            قم بتجميع الصور أو الأفلام من مكتبات الصور أو أجهزة الكمبيوتر إلى السيناريو. أضف بعض التأثيرات إذا كنت ترغب أيضًا.
          </p>
        </>
      )}
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img9}`} />
    </div>
    <div>
      {isLang === "eng" ? (
        <>
          <p>2. Personalize</p>
          <p style={{ fontSize: "16px" }}>
            For more customization, add narration, music, and text to your advertisement. Choose different styling fonts and bright colors.
          </p>
        </>
      ) : (
        <>
          <p>2. تخصيص</p>
          <p style={{ fontSize: "16px" }}>
            للحصول على تخصيص أكبر، أضف السرد، الموسيقى، والنص إلى إعلانك. اختر خطوطًا أنيقة وألوانًا زاهية.
          </p>
        </>
      )}
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img10}`} />
    </div>
    <div>
      {isLang === "eng" ? (
        <>
          <p>3. Export</p>
          <p style={{ fontSize: "16px" }}>
            You may share your promotional media on the internet or download it in different resolutions and ratios by clicking the download option and exporting it to your computer or sharing it on any platform.
          </p>
        </>
      ) : (
        <>
          <p>3. التصدير</p>
          <p style={{ fontSize: "16px" }}>
            يمكنك مشاركة الوسائط الترويجية الخاصة بك على الإنترنت أو تنزيلها بدقة ونسب مختلفة عن طريق النقر فوق خيار التنزيل وتصديرها إلى جهاز الكمبيوتر الخاص بك أو مشاركتها على أي منصة.
          </p>
        </>
      )}
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default Catelog;
